export function cleanObject<T>(obj: Record<string, T | undefined>): Record<string, T> {
  const result: Record<string, T> = {};
  for (const key in obj) {
    if (obj[key] !== undefined && obj[key] !== '') {
      result[key] = obj[key] as T;
    }
  }
  return result;
}

export const EMPTY_UUID = '00000000-0000-0000-0000-000000000000';
